/***
*
*   PROFILE
*   Connection config for ZOHO CRM
*
**********/

import React, { Fragment, useContext, useRef, useEffect } from 'react';
import {
  AuthContext, ViewContext, Form, Card,
  AccountNav, Button, History, Animate, useAPI
} from 'components/lib';
import settings from '../../settings.json';
import axios from 'axios';


export function CRM(props){

  // context
  const authContext = useContext(AuthContext);
  const viewContext  = useContext(ViewContext);

  // user/profile info (unchanged)
  const user = useAPI('/api/account/crm');

  // ZOHO integration status
  // Expected minimal shape from backend:
  // { connected: boolean, org_name?: string, account_name?: string, auth_url?: string }
  const zoho = useAPI('/api/integrations/zoho'); // implement this endpoint server-side

  // util: open centered popup & refresh status when done
  const popupRef = useRef(null);
  // const serverUrl = settings[process.env.NODE_ENV].server_url;
  const serverUrl = 'http://localhost:3000';

  const ENV = (process.env.NODE_ENV || 'development').toLowerCase();

  function openOAuthWindow(url){
    const w = 520, h = 700;
    const y = window.top.outerHeight / 2 + window.top.screenY - (h/2);
    const x = window.top.outerWidth  / 2 + window.top.screenX - (w/2);

    popupRef.current = window.open(
      url,
      'zoho_oauth',
      `toolbar=no,menubar=no,width=${w},height=${h},top=${y},left=${x},resizable=yes,scrollbars=yes`
    );

    // Fallback: poll for window close
    const timer = setInterval(() => {
      if (!popupRef.current || popupRef.current.closed) {
        clearInterval(timer);
        // try refetch if hook supports it, else reload
        if (zoho?.refetch) zoho.refetch();
        else window.location.reload();
      }
    }, 600);

    // Listen for postMessage from popup (optional, if your redirect page posts a message)
    function onMessage(e){
      // You can restrict origin check here if you know it, e.g. if (e.origin !== window.location.origin) return;
      // if (e?.data === 'zoho_oauth_complete') {
      //   window.removeEventListener('message', onMessage);
      //   try { popupRef.current?.close(); } catch {}
      //   if (zoho?.refetch) zoho.refetch();
      //   else window.location.reload();
      // }
    }
    window.addEventListener('message', onMessage);
  }

  async function handleZohoLogout(){
    try{
      await axios.post('/api/integrations/zoho/logout', {
        withCredentials: true
      });
    } catch(e) {
      // optionally surface a toast via your modal/toast system
    } finally {
      if (zoho?.refetch) zoho.refetch();
      else window.location.reload();
    }
  }

async function handleZohoLogin(){
  try {
    const res = await axios.get('/api/integrations/zoho/login', {
      withCredentials: true
    });
    const authUrl = res?.data?.data?.auth_url;
    if (!authUrl) throw new Error('No auth_url');
    openOAuthWindow(authUrl); // your existing popup opener
  } catch (e) {
    console.error('Zoho login init failed', e);
    // show toast/modal as you prefer
  }
}

  function closeAccount(){
    viewContext.modal.show({
      title: 'Close Your Account',
      form: {},
      buttonText: 'Close Account',
      url: authContext.permission.owner ? '/api/account' : '/api/user',
      method: 'DELETE',
      text: 'Are you sure you want to delete your account? You will lose all of your data and this can not be undone.',
    }, () => {
      localStorage.clear();
      History.push('/signup');
    });
  }

  return (
    <Fragment>
      <AccountNav />
      <Animate>
          <Card
            title='Zoho CRM'
            loading={ zoho.loading }
            restrictWidth
          >
            { zoho?.data?.connected ? (
              <div style={{ display: 'grid', gap: 12 }}>
                <div>
                  <strong>Estado:</strong> Conectado
                </div>
                <div>
                  <strong>Cuenta:</strong> {zoho.data.org_name || zoho.data.account_name || '—'}
                </div>
                <div>
                  <Button
                    text='Cerrar sesión'
                    action={ handleZohoLogout }
                  />
                </div>
              </div>
            ) : (
              <div style={{ display: 'grid', gap: 12 }}>
                <div>Conecta tu cuenta para sincronizar contactos y leads desde Zoho CRM.</div>
                <div>
                  <Button
                    text='Conectar con Zoho CRM'
                    action={ handleZohoLogin }
                  />
                </div>
              </div>
            )}
          </Card>

      </Animate>
    </Fragment>
  );
}
